import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useInRouterContext } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import usePhoneLayout from '../Hooks/usePhoneLayout';
let snapshot = null;
export const mapReturnSnapshot = () => snapshot;
export const updateMapReturn = patch => {
 if (patch.selectedProperty && snapshot?.selectedProperty && snapshot.selectedProperty.sequence === patch.selectedProperty.sequence && !patch.selectedProperty.sheetState) {
   patch = { ...patch, selectedProperty: { ...patch.selectedProperty, sheetState: snapshot.selectedProperty.sheetState } };
 }
 snapshot = { ...snapshot, ...patch };
};
export const clearMapReturn = () => { snapshot = null; };
export const notifyMapWorkSaved = () => window.dispatchEvent(new Event('civicode:fieldwork-saved'));
const fieldRoute = path => /^\/(address|situs-addresses|units|violation|complaint|inspection|inspections|observations)(\/|$)/.test(path);
export function MapReturnActions(props) {
 const inRouter = useInRouterContext();
 const phone = usePhoneLayout();
 return inRouter && phone ? <MapReturnActionsContent {...props} /> : (props.fallback || null);
}
function MapReturnActionsContent({ completed = false, onContinue, fallback = null }) {
 const navigate = useNavigate();
 const { user } = useAuth() || {};
 const [dismissed, setDismissed] = useState(false);
 if (!snapshot || dismissed || Number(user?.role) !== 1 || snapshot.userId !== (user?.id == null ? undefined : Number(user.id))) return fallback;
 return <div className="flex flex-wrap gap-2 py-2 wide:hidden" aria-label="Map navigation">
   <button type="button" className="min-h-[44px] rounded-lg border border-border px-3 py-2 text-sm font-semibold text-brand-dark" onClick={() => navigate(snapshot.mapUrl || '/map')}>View map</button>
   {completed && <button type="button" className="min-h-[44px] rounded-lg border border-border px-4 py-2 font-semibold" onClick={() => { if (onContinue) onContinue(); else navigate(propertyReturnPath()); setDismissed(true); }}>Continue at this property</button>}
 </div>;
}
export function propertyReturnPath() {
 const selected = snapshot?.selectedProperty || snapshot?.workLocation;
 if (selected?.unitId) return `/units/${selected.unitId}`;
 const row = selected?.rows?.[selected.sheetState?.chosen ?? 0];
 const site = row?.selectedSitusAddressId ?? selected?.address?.situs_address_id;
 const id = row?.addressId ?? selected?.address?.address_id ?? selected?.address?.id;
 return site ? `/situs-addresses/${site}` : id ? `/address/${id}` : '/map';
}
export function MapReturnBridge() {
 const location = useLocation();
 const { user } = useAuth();
 useEffect(() => () => clearMapReturn(), []);
 const [completed, setCompleted] = useState(false);
 useEffect(() => {
   const edcPropertyRoute = Number(user?.role) === 4 && /^\/(business|contacts|crm\/spaces)(\/|$)/.test(location.pathname);
   if (location.pathname !== '/map' && !fieldRoute(location.pathname) && !edcPropertyRoute) clearMapReturn();
   setCompleted(Boolean(location.state?.fieldworkCompleted));
 }, [location.pathname, location.state, user?.role]);
 useEffect(() => {
   const saved = () => setCompleted(true);
   window.addEventListener('civicode:recheck-synced', saved);
   window.addEventListener('civicode:fieldwork-saved', saved);
   return () => { window.removeEventListener('civicode:recheck-synced', saved); window.removeEventListener('civicode:fieldwork-saved', saved); };
 }, []);
 if (!fieldRoute(location.pathname)) return null;
 return <MapReturnActions key={location.pathname} completed={completed} />;
}
